import React, {Component} from 'react';
import axios from 'axios';
import {connect} from 'react-redux';
import {Label,Menu, Message, Form, Table, Tab} from 'semantic-ui-react';
import {Statistic,Breadcrumb,Divider,Progress, Input, Step, Header,Modal,Dimmer, Loader, Grid, Segment, Item, Image, Popup, Button, Icon, Card, Container} from 'semantic-ui-react';
import {codeStatusToCh, pageTitle} from '../../util';
import QRCode from 'qrcode.react';
import { Link } from 'react-router-dom'
import {fetchUserStatus} from '../actions';
import _ from 'lodash';

const Guide = () => (

  <React.Fragment>
        <Header as='h2'>
          <Header.Content>激活用户获得奖励</Header.Content>
        </Header>
  <Segment>
  <Step.Group ordered>
    <Step >
      <Step.Content>
        <Step.Title>分享您的邀请码</Step.Title>
        <Step.Description>将 <a href="https://github.com/glados-network/GLaDOS">https://github.com/glados-network/GLaDOS</a> </Step.Description>
        <Step.Description>和邀请码推荐给朋友</Step.Description>
      </Step.Content>
    </Step>

    <Step>
      <Step.Content>
        <Step.Title>新用户注册</Step.Title>
        <Step.Description>用户在电脑打开GLaDOS</Step.Description>
        <Step.Description>填入您的代码</Step.Description>
      </Step.Content>
    </Step>

    <Step completed>
      <Step.Content>
        <Step.Title>新用户激活</Step.Title>
        <Step.Description>激活码生效</Step.Description>
        <Step.Description>双方获得天数</Step.Description>
      </Step.Content>
    </Step>

  </Step.Group>
  </Segment>

  </React.Fragment>

)


class SendCode extends Component {
  state = {
    number:"",
    code:"",
    msg:""
  }

  fetchList() {
    axios.get('/user/codes').then((res) => {
      const {code, data} = res.data;
      if (code === 0 && data.gift.length > 0) {
        this.setState({
          code: data.gift[data.gift.length-1].code || "0L5KF-1EPKG-9IEVR-KOCV3"
        });
      }else{
        this.setState({
          code: "0L5KF-1EPKG-9IEVR-KOCV3"
        });
      }
    })
  }

  validate(code) {
    const regex1 = /^1[0-9]*$/;
    return code && regex1.test(code) && new String(code).length == 11;
  }

  constructor(data) {
    super(data)
    this.fetchList();
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e, {name, value}) {
    this.setState({
      [name]: value,
      msg: ''
    });
  }

  render(){

    return (
        <Grid stackable>
            <Grid.Row style={{ display:this.state.code?"block":"none" }} >

            <Grid.Column>
              <p>邀请的方式：</p>
              <p>1. 直接注册GLaDOS(注册地址在 https://github.com/glados-network/GLaDOS 实时更新)</p>
              <p>成功后输入邀请码:<b>{this.state.code}</b> 激活</p>
              <p>2. 通过 https://glados.space/landing/{this.state.code} 注册, 自动填写激活</p>
              <p>3. 通过 https://{this.state.code.toLowerCase()}.glados.space , 自动填写激活</p>
            </Grid.Column>

            </Grid.Row>

        </Grid>
    )
  }
}

const renderGiftCodeList = (data, index) => ({
    key: data.id,
    disabled: data.status !== 'valid',
    cells: [
        {content: data.code, key: 'code'},
        {content: data.days, key: 'days'},
        {content: codeStatusToCh[data.status] || data.status, key: 'status'},
        {content: data.used_times, key: 'used_times'},
        {content: data.used_times * data.days, key: 'all_days'},
    ],
});

const GiftCodeList = ({list}) => (
    <div>
        <Message info attached='top'>
          GLaDOS 采取邀请注册制，请将您的邀请码发给朋友注册，双方都可以获得对应的天数。
        </Message>
        <Table
            attached
            unstackable
            color='orange'
            headerRow={{cells: ['邀请码', '兑换天数', '状态', '使用次数', '累计获得天数']}}
            renderBodyRow={renderGiftCodeList}
            tableData={list}
        />
    </div>
);

const UserFriendsList = ({list}) => (
    <div>

        <Table
            attached
            unstackable
            color='green'
            headerRow={{cells: ['用户ID', '注册时间',"Level", 'Plan']}}
            renderBodyRow={(data, index) => ({
              key: data.phone +"-"+ data.created_at + "-" + Math.random(),
              cells: [
                {
                  content: data.phone,
                  key: "phone-"+data.phone+"-"+data.created_at
                },
                {
                  content: new Date(data.created_at).toLocaleDateString(),
                  key: "days-"+data.created_at
                },
                {
                  content: data.level,
                  key: "phone-"+data.created_at+"-"+data.level
                },
                {
                  content: (<Label color={ data.vip > 10 ? "green":"grey" }>
                    {data.vip == 0 ? "Free":null}
                    {data.vip == 9 ? "Spam":null}
                    {data.vip == 11 ? "Edu":null}
                    {data.vip == 21 ? "Basic":null}
                    {data.vip == 31 ? "Pro":null}
                    {data.vip == 41 ? "Team":null}
                    {data.vip == 51 ? "Enterprise":null}
                  </Label>),
                  key: "status-"+data.created_at+"-"+data.level
                }
              ],
            })}
            tableData={list}
        />
    </div>
);

class CodeList extends Component {

    state = {
      loading: false,
      system: [],
      friends: [],
      gift: [],
    }

    constructor(props) {
        super(...arguments);
        this.fetchList = this.fetchList.bind(this);
        props.onLoad();
    }

    componentDidMount() {
        this.fetchList();
        this.fetchFriends();
        window.scrollTo(0, 0);
    }

    fetchFriends() {
        axios.get('/user/friends').then((res) => {
            const {code, friends} = res.data;
            if (code === 0) {
                this.setState({
                  friends:_.sortBy(friends,(friend)=>{return -1 * friend.vip})
                });
            }
        })
    }

    fetchList() {
        axios.get('/user/codes').then((res) => {
            const {code, data} = res.data;
            if (code === 0) {
                this.setState({
                    system: data.system || [],
                    gift: data.gift || [],
                });
            }
        })
    }

    render() {
        const friends = this.state.friends;
        var split = 20;
        if(this.props.user && this.props.user.info && this.props.user.info.id == 12606){
          split = 50;
        }
        const panes = [
            {
                menuItem: '我的邀请码', render: () => <Tab.Pane loading={this.state.loading}><GiftCodeList list={this.state.gift} /></Tab.Pane>
            },
            {
                menuItem: (
                <Menu.Item key='messages'>
                  我推荐的用户<Label>{friends.filter((i)=>{return i.vip<100}).length}</Label>
                  <Label color="green">{friends.filter((i)=>{return i.vip>20}).length}</Label>
                </Menu.Item>
                )
              , render: () => {
                return (
                <Tab.Pane loading={this.state.loading}><UserFriendsList list={this.state.friends} /></Tab.Pane>
              )}
            }
        ]
        return (
            <div  >

                    <Grid.Row>
                        <Grid.Column>
                            <Header as='h2' style={{marginTop:"3px"}}>
                                <Header.Content>发送内部邀请</Header.Content>
                            </Header>

                            <p>分享您的邀请链接，用户可以注册GLaDOS, 并得到初始天数。</p>

                            <p>邀请计划：</p>

                            <p>1. 您会得到获得当前会员的延期。</p>
                            <p>2. 新用户注册后获得随机奖励: 0-0.1 美元[1]。</p>
                            <p>3. 新用户付费后获得 25% 分账[2], 续费同样分账。</p>
                            <p>4. 新用户付费后获得 14 天会员延期。</p>

                            <small>[1]非活动用户不进行奖励</small><br/>
                            <small>[2]分账指每单扣除银行和支付公司等交易费用后的收入</small>

                            <Divider />

                            <SendCode/>
                            <Guide/>
                            <Divider />
                            <Tab  style={{ marginTop:10 }} panes={panes} />

                        </Grid.Column>
                    </Grid.Row>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {user: state.user};
};

const mapDispatchToProps = (dispatch) => {
    return {
        onLoad: () => {
            dispatch(fetchUserStatus());
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CodeList);
